import { forwardRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { ImageStyleCard, NewImageStyleCard } from 'src/components/ImageStyleCard';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  generalStyles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  customStyles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedId: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onCreateStyle: PropTypes.func.isRequired,
  onEditStyle: PropTypes.func.isRequired,
  onDeleteStyle: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

const defaultProps = {
  className: '',
  selectedId: null,
  disabled: false,
};

export const ImageStyleList = forwardRef(
  (
    {
      className,
      generalStyles,
      customStyles,
      selectedId,
      onSelect,
      onCreateStyle,
      onEditStyle,
      onDeleteStyle,
      disabled,
    },
    ref
  ) => {
    const styles = useStyles();

    return (
      <div
        className={cx(styles.root, className)}
        ref={ref}
      >
        <div className={styles.groupContainer}>
          <div className={styles.header}>
            <CustomTypography
              className={styles.title}
              variant={TYPOGRAPHY_VARIANT.medium16}
            >
              Custom
            </CustomTypography>
          </div>

          <div className={styles.cards}>
            <NewImageStyleCard
              className={cx(styles.card, styles.newCard)}
              onClick={onCreateStyle}
            />

            {customStyles?.map((customStyle) => (
              <ImageStyleCard
                className={styles.card}
                key={customStyle.id}
                imageStyle={customStyle}
                visualLanguage={customStyle.visualLanguage}
                onClick={() => onSelect(customStyle)}
                onEdit={() => onEditStyle(customStyle)}
                onDelete={() => onDeleteStyle(customStyle)}
                selected={customStyle.id === selectedId}
                disabled={disabled}
              />
            ))}
          </div>
        </div>

        <div className={styles.groupContainer}>
          <div className={styles.header}>
            <CustomTypography
              className={styles.title}
              variant={TYPOGRAPHY_VARIANT.medium16}
            >
              General
            </CustomTypography>
          </div>

          <div className={styles.cards}>
            {generalStyles?.map((generalStyle) => (
              <ImageStyleCard
                className={styles.card}
                key={generalStyle}
                imageStyle={generalStyle}
                onClick={() => onSelect(generalStyle)}
                selected={generalStyle.id === selectedId}
                disabled={disabled}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
);

ImageStyleList.displayName = 'ImageStyleList';
ImageStyleList.propTypes = propTypes;
ImageStyleList.defaultProps = defaultProps;
